let flowLoaded = false;


window.falarAtendente = function () {
  window.location.assign("https://wa.me/554391274999?text=Ol%C3%A1%2C%20tenho%20d%C3%BAvidas%20sobre%20Tropicadelia ");
  // window.location.assign("https://wa.me/...");
};

function loadFlow () {
  if (flowLoaded) return;
  flowLoaded = true;
  const s = document.createElement('script');
  s.src = 'https://flow.vetrio.app/api/public/launches/embed/reabertura';
  s.async = true;
  document.body.appendChild(s);
}

window.clickBtnGrupo = function () {
  
  window.location.assign("https://baladapp.com.br/pt-BR/evento/tropicadelia-londrina/8250");
  
};

window.fecharModal = function () {
  const modal = document.getElementById("modal-one");
  modal.classList.remove("open");
  const body = document.getElementById("body");
  body.classList.remove("open");
};

window.fecharMenu = function () {
  const menu = document.getElementById("navi-toggle");
  menu.checked = false;
};

window.verMapa = function (stage) {
  const mapa = document.getElementById("mapa");
  mapa.scrollIntoView({ behavior: "smooth" });
};
